import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_COLOR = '#5986ff';

const ColorPicker = ({ color, onChange }) => (
  <input
    className="form-control"
    type="color"
    value={color || DEFAULT_COLOR}
    onChange={e => onChange(e.target.value)}
    style={{ cursor: 'pointer' }}
  />
);

ColorPicker.propTypes = {
  color: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

ColorPicker.defaultProps = {
  color: ''
};

export default ColorPicker;
